document.addEventListener('DOMContentLoaded', function () {
    
    // Additional Products Variant Selection Handler
    function initAdditionalProductsVariants() {
        const additionalProductItems = document.querySelectorAll('.additional-product-item');
        
        additionalProductItems.forEach(item => {
            const productHandle = item.getAttribute('data-additional-product-item');
            const variantSelects = item.querySelectorAll('.additional-product-variant-select');
            const colorSwatches = item.querySelectorAll('.additional-product-color-swatch');
            const sizeButtons = item.querySelectorAll('.additional-product-size-button');
            const variantData = item.querySelector('.additional-product-variants-data');
            
            if (!variantData) return;
            
            let variants;
            try {
                variants = JSON.parse(variantData.textContent);
            } catch (e) {
                console.error('Error parsing variant data for', productHandle, e);
                return;
            }
            
            // Function to find matching variant based on selected options
            function findMatchingVariant() {
                const selectedOptions = {};
                
                // Get all selected options from dropdowns
                variantSelects.forEach(select => {
                    const position = parseInt(select.getAttribute('data-option-position'));
                    selectedOptions[position] = select.value;
                });
                
                // Get all selected options from color swatches
                colorSwatches.forEach(swatch => {
                    if (swatch.classList.contains('active')) {
                        const position = parseInt(swatch.getAttribute('data-option-position'));
                        const value = swatch.getAttribute('data-option-value-raw');
                        selectedOptions[position] = value;
                    }
                });
                
                // Get all selected options from size buttons
                sizeButtons.forEach(button => {
                    if (button.classList.contains('active')) {
                        const position = parseInt(button.getAttribute('data-option-position'));
                        const value = button.getAttribute('data-option-value-raw');
                        selectedOptions[position] = value;
                    }
                });
                
                // Find variant that matches all selected options
                return variants.find(variant => {
                    return Object.keys(selectedOptions).every(position => {
                        const optionIndex = parseInt(position) - 1;
                        return variant.options[optionIndex] === selectedOptions[position];
                    });
                });
            }
            
            // Function to update variant selection
            function updateVariantSelection() {
                const matchingVariant = findMatchingVariant();
                
                if (matchingVariant) {
                    // Update hidden input with selected variant ID
                    const hiddenInput = item.querySelector('.selected-variant-id');
                    if (hiddenInput) {
                        hiddenInput.value = matchingVariant.id;
                    }
                    
                    // Update price display
                    const priceContainer = item.querySelector('.additional-product-price');
                    if (priceContainer) {
                        let priceHTML = '';
                        
                        if (matchingVariant.compare_at_price && matchingVariant.compare_at_price > matchingVariant.price) {
                            priceHTML = `
                                <span class="price-sale">${formatMoney(matchingVariant.price)}</span>
                                <span class="price-compare">${formatMoney(matchingVariant.compare_at_price)}</span>
                            `;
                        } else {
                            priceHTML = `<span class="price-regular">${formatMoney(matchingVariant.price)}</span>`;
                        }
                        
                        priceContainer.innerHTML = priceHTML;
                    }
                    
                    // Check if variant is unavailable and update CTA button
                    updateCTAButtonState(matchingVariant);
                    
                    // Update availability states for other options
                    updateOptionAvailability();
                }
            }
            
            // Function to update CTA button state based on variant availability
            function updateCTAButtonState(variant) {
                // Get the currently checked plan type
                const checkedPlanInput = document.querySelector('input[name="nw-plan-picker"]:checked');
                if (!checkedPlanInput) return;
                
                const checkedPlanValue = checkedPlanInput.value;
                
                // Find the CTA button in the currently active plan section
                let addButton;
                if (checkedPlanValue === 'subscription') {
                    addButton = document.querySelector('.nw-plan-picker-item--subscription .nw-plan-picker-cta-button');
                } else if (checkedPlanValue === 'one-time') {
                    addButton = document.querySelector('.nw-plan-picker-item--one-time .nw-plan-picker-cta-button');
                }
                
                if (!addButton) return;
                
                if (variant && !variant.available) {
                    // Variant is unavailable - disable button
                    addButton.setAttribute('disabled', 'disabled');
                    addButton.classList.add('disabled');
                    
                    const buttonTextSpan = addButton.querySelector('span');
                    if (buttonTextSpan) {
                        if (!addButton.dataset.originalText) {
                            addButton.dataset.originalText = buttonTextSpan.textContent;
                        }
                        buttonTextSpan.textContent = 'Out of Stock';
                    }
                } else {
                    // Variant is available - enable button
                    addButton.removeAttribute('disabled');
                    addButton.classList.remove('disabled');
                    
                    const buttonTextSpan = addButton.querySelector('span');
                    if (buttonTextSpan) {
                        const originalText = addButton.dataset.originalText || 'Add to cart';
                        buttonTextSpan.textContent = originalText;
                    }
                }
            }
            
            // Function to update option availability based on current selections
            function updateOptionAvailability() {
                const selectedOptions = {};
                
                // Get currently selected options
                variantSelects.forEach(select => {
                    const position = parseInt(select.getAttribute('data-option-position'));
                    selectedOptions[position] = select.value;
                });
                
                colorSwatches.forEach(swatch => {
                    if (swatch.classList.contains('active')) {
                        const position = parseInt(swatch.getAttribute('data-option-position'));
                        const value = swatch.getAttribute('data-option-value-raw');
                        selectedOptions[position] = value;
                    }
                });
                
                sizeButtons.forEach(button => {
                    if (button.classList.contains('active')) {
                        const position = parseInt(button.getAttribute('data-option-position'));
                        const value = button.getAttribute('data-option-value-raw');
                        selectedOptions[position] = value;
                    }
                });
                
                // Check availability for each select dropdown
                variantSelects.forEach(select => {
                    const currentPosition = parseInt(select.getAttribute('data-option-position'));
                    const options = select.querySelectorAll('option');
                    
                    options.forEach(option => {
                        if (option.value === '') return; // Skip empty options
                        
                        const testOptions = { ...selectedOptions };
                        testOptions[currentPosition] = option.value;
                        
                        // Check if any variant matches these options and is available
                        const hasAvailableVariant = variants.some(variant => {
                            const matches = Object.keys(testOptions).every(pos => {
                                const optionIndex = parseInt(pos) - 1;
                                return variant.options[optionIndex] === testOptions[pos];
                            });
                            return matches && variant.available;
                        });
                        
                        // Update option availability (but don't disable - just add class for styling)
                        if (hasAvailableVariant) {
                            option.classList.remove('variant-unavailable-option');
                            option.textContent = option.textContent.replace(' (Sold Out)', '');
                        } else {
                            option.classList.add('variant-unavailable-option');
                            if (!option.textContent.includes('(Sold Out)')) {
                                option.textContent += ' (Sold Out)';
                            }
                        }
                    });
                });
                
                // Check availability for each size button
                sizeButtons.forEach(button => {
                    const currentPosition = parseInt(button.getAttribute('data-option-position'));
                    const buttonValue = button.getAttribute('data-option-value-raw');
                    
                    const testOptions = { ...selectedOptions };
                    testOptions[currentPosition] = buttonValue;
                    
                    // Check if any variant matches these options and is available
                    const hasAvailableVariant = variants.some(variant => {
                        const matches = Object.keys(testOptions).every(pos => {
                            const optionIndex = parseInt(pos) - 1;
                            return variant.options[optionIndex] === testOptions[pos];
                        });
                        return matches && variant.available;
                    });
                    
                    // Update button styling based on availability
                    if (hasAvailableVariant) {
                        button.classList.remove('variant-unavailable');
                        button.setAttribute('data-is-available', 'true');
                    } else {
                        button.classList.add('variant-unavailable');
                        button.setAttribute('data-is-available', 'false');
                    }
                });
                
                // Check availability for each color swatch
                colorSwatches.forEach(swatch => {
                    const currentPosition = parseInt(swatch.getAttribute('data-option-position'));
                    const swatchValue = swatch.getAttribute('data-option-value-raw');
                    
                    const testOptions = { ...selectedOptions };
                    testOptions[currentPosition] = swatchValue;
                    
                    // Check if any variant matches these options and is available
                    const hasAvailableVariant = variants.some(variant => {
                        const matches = Object.keys(testOptions).every(pos => {
                            const optionIndex = parseInt(pos) - 1;
                            return variant.options[optionIndex] === testOptions[pos];
                        });
                        return matches && variant.available;
                    });
                    
                    // Update swatch styling based on availability
                    if (hasAvailableVariant) {
                        swatch.classList.remove('variant-unavailable');
                        swatch.setAttribute('data-is-available', 'true');
                    } else {
                        swatch.classList.add('variant-unavailable');
                        swatch.setAttribute('data-is-available', 'false');
                    }
                });
            }
            
            // Add event listeners to variant selects
            variantSelects.forEach(select => {
                select.addEventListener('change', function() {
                    updateVariantSelection();
                });
            });
            
            // Add event listeners to color swatches
            colorSwatches.forEach(swatch => {
                swatch.addEventListener('click', function(e) {
                    e.preventDefault();
                    
                    const position = swatch.getAttribute('data-option-position');
                    const productHandle = swatch.getAttribute('data-product-handle');
                    const colorName = swatch.getAttribute('data-swatch-color-name');
                    
                    // Remove active class from siblings in the same option group
                    const parentList = swatch.closest('.product-color-options__list');
                    if (parentList) {
                        parentList.querySelectorAll('.additional-product-color-swatch').forEach(sibling => {
                            sibling.classList.remove('active');
                            sibling.setAttribute('aria-pressed', 'false');
                        });
                    }
                    
                    // Add active class to clicked swatch
                    swatch.classList.add('active');
                    swatch.setAttribute('aria-pressed', 'true');
                    
                    // Update main product image slider based on selected color
                    if (colorName) {
                        const targetAlt = `Swatch:${colorName}`;
                        const slideElement = document.querySelector(`[data-image-alt="${targetAlt}"]`);
                        
                        if (slideElement) {
                            const slideIndex = parseInt(slideElement.getAttribute('data-index'));
                            if (!isNaN(slideIndex)) {
                                // Get the swiper instance from the DOM element
                                const featuredSliderElement = document.querySelector('.featured_image_slider');
                                if (featuredSliderElement && featuredSliderElement.swiper) {
                                    featuredSliderElement.swiper.slideTo(slideIndex);
                                }
                            }
                        }
                    }
                    
                    // Update variant selection
                    updateVariantSelection();
                });
            });
            
            // Add event listeners to size buttons
            sizeButtons.forEach(button => {
                button.addEventListener('click', function(e) {
                    e.preventDefault();
                    
                    // Remove disabled check - allow clicking unavailable variants
                    // if (button.disabled) return;
                    
                    const position = button.getAttribute('data-option-position');
                    const productHandle = button.getAttribute('data-product-handle');
                    
                    // Remove active class from siblings in the same option group
                    const parentList = button.closest('.product-size-options__list');
                    if (parentList) {
                        parentList.querySelectorAll('.additional-product-size-button').forEach(sibling => {
                            sibling.classList.remove('active');
                            sibling.setAttribute('aria-pressed', 'false');
                        });
                    }
                    
                    // Add active class to clicked button
                    button.classList.add('active');
                    button.setAttribute('aria-pressed', 'true');
                    
                    // Update variant selection
                    updateVariantSelection();
                });
            });
            
            // Initialize with first available variant
            updateVariantSelection();
            updateOptionAvailability();
        });
    }
    
    // Simple money formatting function (you might want to use Shopify's money filters)
    function formatMoney(cents) {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
            return Shopify.formatMoney(cents);
        }
        // Fallback formatting
        return '$' + (cents / 100).toFixed(2);
    }
    
    // Initialize additional products variants
    initAdditionalProductsVariants();
    
});
